import { HelmetDexteel } from "@dexteel/mesf-core";
import { RollMaterialsManager } from "./components/RollMaterialsManager";

export const RollMaterialsPage = () => {
	return (
		<>
			<HelmetDexteel title="Roll Materials" />
			<RollMaterialsManager />
		</>
	);
};
